import { computed, getCurrentInstance, inject, provide, ref, unref } from 'vue'

import type { InjectionKey } from 'vue'

export const throneContextKey: InjectionKey<Ref<Record<string, any> | undefined>> = Symbol('throneContext')

import type { App, Ref } from 'vue'
import type { ThroneContextProviderContext } from '../../components/Throne/ThroneContextProvider'


export function useThroneContext(): Ref<Record<string, any> | undefined> | undefined {
  const context = inject(throneContextKey, undefined)
  return context
}

export const provideThroneContext = (props: ThroneContextProviderContext) => {
  const context = computed(() => {
    return props.context || undefined
  })

  provide(throneContextKey, context)

  return context
}
